import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import { App } from './App';

import { reducer } from './redux/MenLikeMe.reducer';
import { rootSaga } from './redux/MenLikeMe.sagas';

import './utils/window.truenth.utils';
import './utils/window.truenth.cookies';

// Register dataLayer in the window object
window.dataLayer = window.dataLayer || [];

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// dev tools middleware
// eslint-disable-next-line no-underscore-dangle
// const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

// create a redux store with our reducer above and middleware
const store = createStore(
  reducer,
  compose(
    applyMiddleware(sagaMiddleware)
    // reduxDevTools
  )
);

// run the saga
sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
